import React from "react";
import PropTypes from "prop-types";
import Api from "js/api/authorisedApi";
import NuSingleSelect from "../NuSingleSelect";
import AlienNippleLoader from "../AlienNippleLoader";
import { applyInputErrorStyling, removeInputErrorStyling } from "js/utils/dynamicStyling";
import PrivacyPolicy from "./components/PrivacyPolicy";
import { withRouter } from "js/components/Root/withRouter";
import { useThemeStore } from "stores/v2/themeStore";
import { useUserSessionStore } from "stores/v2/userSessionStore";
import { useAcademyMFEContextStore } from "@/stores/v2/academyMFEContextStore";

class Login extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			deviceid: localStorage.getItem("LOGIN_DEVICEID"),
			devices: [],
			showLogin: false,
			loadingSchool: false,
		};

		this.schoolSelectElement = null;
		this.unsubUserSessionStore = () => {};
	}

	componentDidMount() {
		// Initialize training params from URL if they exist
		useAcademyMFEContextStore.getState().parseAndSetTrainingParams(window.location.href);
		// Set masquerade to false to hide the Academy MFE if it should be hidden
		useUserSessionStore.getState().setMasquerade(false);
		Api.unauthenticatedGet("/sites", (response) => {
			if (response.data !== undefined) {
				this.setState({
					devices: response.data,
				});
			}
		});

		this.unsubUserSessionStore = useUserSessionStore.subscribe(this.onChange);
	}

	componentWillUnmount() {
		this.unsubUserSessionStore();
	}

	onChange = () => {
		if (useUserSessionStore.getState().isAuthenticated()) {
			this.props.router.navigate("/");
		}
	};

	find_region_and_name(deviceid) {
		for (const device of this.state.devices) {
			if (device.deviceid === deviceid) {
				return {
					region: device.region,
					name: device.name,
				};
			}
		}
	}

	handleChangeSchool = (value) => {
		this.setState({
			deviceid: value,
		});
		removeInputErrorStyling(this.schoolSelectElement);
	};

	handleNextClicked = () => {
		if (!this.state.deviceid) {
			applyInputErrorStyling(this.schoolSelectElement);
			return;
		}
		this.setState({ loadingSchool: true });
		const device = this.find_region_and_name(this.state.deviceid);
		localStorage.setItem("LOGIN_DEVICEID", this.state.deviceid);
		localStorage.setItem("LOGIN_DEVICENAME", device.name);

		Api.unauthenticatedGet(`/get/tenant_key/from/device_id?device_id=${this.state.deviceid}`, (data) => {
			this.props.router.navigate("/login/" + data.data["tenant_key"], { state: { fromSchoolSelectPage: true } });
		});
	};

	prepareAvailableSchools = () => {
		const ret = [];
		for (let i = 0; i < this.state.devices.length; i++) {
			const device = this.state.devices[i];
			var deviceMenuItem = {
				value: device["deviceid"],
				text: device["name"],
			};
			if (!deviceMenuItem["text"]) {
				deviceMenuItem["text"] = device["deviceid"];
			}
			ret.push(deviceMenuItem);
		}
		return ret;
	};

	renderLoginStage = () => {
		if (this.state.devices.length === 0) {
			// loading
			return (
				<div className="login-schools-loading-container">
					<AlienNippleLoader />
					<span className="schools-loading-text">Loading list of schools. Please wait...</span>
					<button disabled className={"large login-next-button large-btn-disabled"}>
						Next
					</button>
				</div>
			);
		} else if (this.state.loadingSchool) {
			return (
				<div className="login-schools-loading-container">
					<AlienNippleLoader />
					<span className="schools-loading-text">Loading school login. Please wait...</span>
					<button disabled className={"large login-next-button large-btn-disabled"}>
						Next
					</button>
				</div>
			);
		} else {
			return this.renderSchoolSelect();
		}
	};
	renderSchoolSelect = () => {
		return (
			<div className="login-school-select">
				<h4>Select your school or district to get started</h4>
				<NuSingleSelect
					allItems={this.prepareAvailableSchools()}
					selectedItem={this.state.deviceid}
					searchPlaceholder="Schools"
					onChange={this.handleChangeSchool}
					searchContainerRef={(el) => (this.schoolSelectElement = el)}
				/>
				{this.state.nextButtonShowLoader ? (
					<button className="large login-next-button">
						<div>
							<i className="fa fa-refresh fa-spin fa-fw" />
						</div>
					</button>
				) : (
					<button className="large login-next-button" onClick={this.handleNextClicked}>
						Next
					</button>
				)}
			</div>
		);
	};

	render() {
		return (
			<div id="login-main-content" data-testid="login-main-content">
				<div className="background">
					<div className="background-left" />
					<div className="background-right" />
				</div>
				<div className="flex-row-center privacy">
					<div className="login-content">
						<div className={useThemeStore.getState().theme === "smoothwall" ? "login-logo-smoothwall" : "login-logo"} />
						{useThemeStore.getState().theme === "linewize" && <h1>Classwize</h1>}
						<h3>TEACHER PORTAL</h3>
						<div className="login-content-inner">{this.renderLoginStage()}</div>
					</div>
				</div>
				<PrivacyPolicy />
			</div>
		);
	}
}

Login.propTypes = {
	router: PropTypes.object.isRequired,
};

export default withRouter(Login);
